module.exports = __webpack_public_path__ + "08_mole.8573efa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer2/08_mole.png
// module id = NC7s
// module chunks = 0